import { Skeleton } from '@/components/ui/skeleton';

export function TrackingDiagramPageLoading() {
  return (
    <div className="flex flex-col h-screen w-full">
      {/* Skeleton for IntegrationDiagram */}
      <div className="p-4">
        <Skeleton className="h-[226px] w-full" />
      </div>

      <div className="p-4 border-t">
        <Skeleton className="h-20 w-full" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-6 mb-10">
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-40 w-full" />
        </div>
      </div>
      <div className="p-4 border-t">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-6 mb-10">
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-40 w-full" />
        </div>
      </div>
    </div>
  );
}
